import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { filterNil } from '@ngneat/elf';
import { map } from 'rxjs';
import { getScheduleEventUrl } from 'src/app/common/utils/url';
import { AlertUser, EventAlertEntity } from 'src/app/models/alert';
import { AlertService } from 'src/app/services/alert.service';
import {
  IconConfig,
  IconTypes,
} from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import { RelatedLinkRowComponent } from '../related-link-row/related-link-row.component';
import { RelatedUserRowComponent } from '../related-user-row/related-user-row.component';

@Component({
  selector: 'app-related-event',
  templateUrl: './related-event.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TranslateModule, RelatedUserRowComponent, RelatedLinkRowComponent],
})
export class RelatedEventComponent {
  readonly eventIcon: IconConfig = { name: 'calender-event', type: IconTypes.svgIcon };

  constructor(private readonly alertService: AlertService) {}

  /**
   * Read off the selected alert rather than re-fetching the event: GET /alerts
   * nested-populates the event's hosts and participants via populateAlertDetails,
   * so everything these rows render is already on `alert.entity`.
   */
  public readonly relatedEventData$ = this.alertService.selectedAlert$.pipe(
    filterNil(),
    // Cast on the same grounds as AlertViewModelFactory.get: this component is only
    // rendered for event-backed alerts, whose entity is the populated Event.
    map((alert) => this.toRelatedEventData(alert.entity as EventAlertEntity)),
  );

  private toRelatedEventData(event: EventAlertEntity) {
    return {
      link: { text: event?.title ?? '', url: getScheduleEventUrl(event?._id ?? '') },
      organizers: (event?.host_ids ?? []) as (AlertUser | null)[],
      attendees: (event?.participants ?? []).map(
        (participant) => participant.user_id,
      ) as (AlertUser | null)[],
    };
  }
}
